import {GetBanners} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetBanners} from 'data/usecases';
import {BannersEndPoint} from 'main/factories/usecases/endpoints';

export const makeGetBanners = (): GetBanners =>
	new RemoteGetBanners(
		makeBFFApiUrl(BannersEndPoint.banners),
		makeAuthorizeHttpClientDecorator(),
	);
